import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import App from './App.jsx'
import { PBCC_PREMIUM } from './config/siteMode.js'
import { startAutoUpdate } from './lib/autoUpdate.js'
import './styles.css'

// Premium admin theme is TEST-ONLY (pbcc-tourney-test). Gate the whole cream/gold
// CSS layer behind a single html class so it can never reach the club, even on a
// FOURBALL rebuild of THEIRS. All premium rules in styles.css are scoped under it.
if (PBCC_PREMIUM) document.documentElement.classList.add('pbcc-premium')

// TEST: capture the PWA install prompt so the qualify finish screen can offer a
// one-tap "Add to Home Screen" (Android). iOS uses the Share-sheet steps. No
// service worker is registered (kept off to avoid stale caches).
if (PBCC_PREMIUM && typeof window !== 'undefined') {
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault()
    window.__pbccInstallPrompt = e
    try { window.dispatchEvent(new Event('pbcc-install-available')) } catch { /* ignore */ }
  })
}

// Bumping APP_VERSION in vite.config.js changes this string at build time and
// therefore changes the bundle hash. Logged so you can see which version is
// running in DevTools console.
// eslint-disable-next-line no-console
console.log('[CompleteTourneyLive] v' + (typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : 'dev'))

// Auto-update: force a reload whenever a newer build is deployed, so no device is
// ever trapped on a stale cache. Runs alongside the no-store index.html + the
// self-destructing SW cleanup (see index.html) for defence in depth.
startAutoUpdate()

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
)
